<app-chat-widget></app-chat-widget>
<footer class="footer">

    <div class="container text-center">
        <h3 class="section-title text-white">Get To Know Us More</h3>
        <p class="footer-description">
            How WhiteRobe, a digital platform, is offering endless possibilities and uniting hearts<br>all at the same time.
            
        </p>


        <!-- <a class="contact-btn mt-4" (click)="goTo('/contact-us')">
            Contact
            <span class="arr-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor"
                    class="bi bi-arrow-up-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z" />
                </svg>
            </span>
        </a> -->

        <div class="footer-bottom">
            <p>Copyright © 2025 All Rights Reserved |
                 <a (click)="goTo('/privacy')" style="cursor: pointer;">Privacy Policy</a> |
                  <a (click)="goTo('/terms-and-conditions')" style="cursor: pointer;">Terms and Conditions</a> |
                   <a (click)="goTo('/pricing-policy')" style="cursor: pointer;">Pricing Policy</a> |
                    <a (click)="goTo('/refund-policy')" style="cursor: pointer;">Refund Policy</a> |
                     <a (click)="goTo('/cancellation-policy')" style="cursor: pointer;">Cancellation Policy</a>
                    </p>
        </div>
        <hr>
        <div class="footer-down-links">
            <div>
                <img src="assets/images/logo-WR.svg" width="150px" alt="">
            </div>
            <div class="footer-links">
                <a class="pointer" (click)="goTo('/')" >Home</a>
                <a class="pointer" (click)="goTo('/about-us')" >About</a>
                <a class="pointer" (click)="goTo('/our-services')" >Services</a>
                <a class="pointer" href="https://blog.whiterobe.in/" target="_blank" >Blog</a>
            </div>

            <div class="social-icons">
                <!-- <a href="#"><i class="fab fa-discord"></i></a> -->
                <a href="https://www.facebook.com/whiterobein" target="_blank"><i class="fa fa-facebook-square"
                        aria-hidden="true"></i>
                </a>
                <a href="https://x.com/Whiterobein" target="_blank"><i class="fab fa-x-twitter" aria-hidden="true"></i></a>

                <a href=" https://www.instagram.com/whiterobe.in/ " target="_blank"><i class="fa fa-instagram"
                        aria-hidden="true"></i></a>
                <a href="https://www.linkedin.com/company/whiterobe" target="_blank"><i class="fa fa-linkedin-square"
                        aria-hidden="true"></i>

                </a>

                <a href="https://in.pinterest.com/whiterobein/" target="_blank"><i class="fa fa-pinterest-square"
                        aria-hidden="true"></i>

                </a>
                <a href="https://www.youtube.com/@WhiteRobein/" target="_blank"><i class="fa-brands fa-youtube"></i>

                </a>
                <!-- <a href="https://www.youtube.com/@WhiteRobein/" target="_blank"><i class="fa-brands fa-app-store-ios"></i>
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.app.whiterobe" target="_blank"><i class="fa-brands fa-google-play"></i>
                </a> -->
            </div>
        </div>
    </div>
</footer>